<template>
	<form @submit.prevent="submit">
		<div class="container">
			<div class="row pb-3">
				<div class="col-12">
					<h2 class="h3 title font-alt text-purple">Sponsor Options</h2>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
						<p :class="{ 'text-danger' : errors.amount}">Would you like to sponsor {{ profile.name }} <strong>every month</strong> or with a <strong>single payment</strong>?</p>
				</div>
			</div>
			<div class="row">

				<price-box @click="selectedFrequency = 'monthly'" ref="priceBoxMonthly"
						   :class="{ 'border border-danger': (!$v.selectedAmount.required && $v.selectedAmount.$dirty)}"
						   title="Monthly" :plans="plans" :profile="profile" frequency="monthly"
						   :defaultPlan="5"
						   @selectPlan="selectPlan"
						   :customAmount="60"
						   :isSelected="selectedFrequency === 'monthly'"
				></price-box>
				<price-box @click="selectedFrequency = 'one-off'" ref="priceBoxOneOff"
						   title="Single Payment" :plans="oneOffPlans" :profile="profile" frequency="one-off"
						   @selectPlan="selectPlan"
						   :customAmount="100"
						   :isSelected="selectedFrequency === 'one-off'"
				></price-box>

			</div>
		</div>

		<div class="container">
			<div class="row">
				<div class="col-12">
					<hr class="border border-secondary">
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<p class="font-weight-bold">Who are you sponsoring {{ profile.name }} for?</p>
					<p>You can choose to sponsor {{ profile.name }} for yourself or as a gift for someone else.
						We will post your sponsor pack to the address you enter.</p>
						<div class="my-3 d-inline-block custom-control custom-control-purple custom-checkbox">
							<input type="checkbox" class="custom-control-input"  name="no-pack" v-model="no_pack" id="noPack">
							<label class="custom-control-label" for="noPack">
								If you prefer not to receive a sponsor pack, please tick this box
							</label>
						</div>
				</div>
			</div>
			<div class="row px-3">
				<div @click="sponsorFor = 0"
					 class="col-12 col-lg-6 text-center py-4 cursor-pointer"
					 :class="{ 'bg-purple' : sponsorFor === 0, 'border-purple' : sponsorFor === 1}">

					 <span class="mr-1 custom-control custom-control-purple custom-checkbox">
						  <input type="checkbox" class="custom-control-input" name="sponsorFor"
								 id="sponsorFor0" :checked="sponsorFor === 0" @click.prevent>
						  <label class="custom-control-label" for="sponsorFor0" @click="sponsorFor = 0">
							  I'm sponsoring for MYSELF
						  </label>
					  </span>


				</div>
				<div @click="sponsorFor = 1"
					 class="col-12 col-lg-6 text-center py-4 cursor-pointer"
					 :class="{ 'bg-purple' : sponsorFor === 1, 'border-purple' : sponsorFor === 0}">
					<span class="mr-1 custom-control custom-control-purple custom-checkbox">
						  <input type="checkbox" class="custom-control-input" name="sponsorFor"
								 id="sponsorFor1" :checked="sponsorFor === 1" @click.prevent>
						  <label class="custom-control-label" for="sponsorFor1" @click="sponsorFor = 1">
							  Sponsor as a GIFT for someone else
						  </label>
					  </span>

				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<hr class="border border-secondary">
				</div>
			</div>
		</div>

		<!-- Your Details -->
		<div class="container">
			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="row">
						<div class="col-12">
							<h4>Your Details</h4>
						</div>
					</div>
					<div class="row px-3">
						<div class=" col-12 bg-purple-light p-3">
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_title">Title</label>
									<input type="text" class="form-control" name="title" id="sender_title"
										   :class="{ 'border border-danger': (!$v.sender_title.required  && $v.sender_title.$dirty)}"
										   v-model.trim="sender_title"
										   @input="setTitle($event.target.value)"
										   autocomplete="title"
										   placeholder="e.g, Mr, Mrs, Miss, Dr, Rev, etc"
									>
									<div class="text-danger" v-if="!$v.sender_title.required && $v.sender_title.$dirty">
										Title is required
									</div>
									<div class="text-danger"
										 v-if="!$v.sender_title.minLength && $v.sender_title.$dirty">Name must have at
										least {{ $v.sender_title.$params.minLength.min }} letters.
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_first_name">First Name</label>
									<input type="text" class="form-control" name="first_name" id="sender_first_name"
										   :class="{ 'border border-danger': (!$v.sender_first_name.required  && $v.sender_first_name.$dirty)}"
										   v-model="sender_first_name" autocomplete="name">
									<div class="text-danger"
										 v-if="!$v.sender_first_name.required && $v.sender_first_name.$dirty">First name
										is required
									</div>
									<div class="text-danger"
										 v-if="!$v.sender_first_name.minLength && $v.sender_first_name.$dirty">First
										Name must have at least {{ $v.sender_first_name.$params.minLength.min }}
										letters.
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_first_name">Last Name</label>
									<input type="text" class="form-control" name="last_name" id="sender_last_name"
										   :class="{ 'border border-danger': (!$v.sender_last_name.required  && $v.sender_last_name.$dirty)}"
										   v-model="sender_last_name" autocomplete="name">
									<div class="text-danger"
										 v-if="!$v.sender_last_name.required && $v.sender_last_name.$dirty">Last name is
										required
									</div>
									<div class="text-danger"
										 v-if="!$v.sender_last_name.minLength && $v.sender_last_name.$dirty">Last Name
										must have at least {{ $v.sender_last_name.$params.minLength.min }} letters.
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_email">Email</label>
									<input type="email" class="form-control" name="email" id="sender_email"
										   :class="{ 'border border-danger': (!$v.sender_email.required  && $v.sender_email.$dirty)}"
										   v-model="sender_email" autocomplete="email">
									<div class="text-danger" v-if="!$v.sender_email.required && $v.sender_email.$dirty">
										Email is required
									</div>
									<div class="text-danger" v-if="!$v.sender_email.email && $v.sender_email.$dirty">
										That email address is invalid.
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6 mt-3 mt-lg-0" v-if="sponsorFor === 0">
					<div class="row">
						<div class="col-12">
							<h4>Your Address</h4>
						</div>
					</div>
					<div class="row px-3">
						<div class=" col-12 bg-purple-light p-3">
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_street">House number &amp; Street</label>
									<input type="text" class="form-control" name="street" id="sender_street"
										   :class="{ 'border border-danger': (!$v.sender_address_line_1.required && $v.sender_address_line_1.$dirty)}"
										   v-model="sender_address_line_1" autocomplete="street-address">
									<div class="text-danger"
										 v-if="!$v.sender_address_line_1.required && $v.sender_address_line_1.$dirty">
										House number &amp; Street is required
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_town">Town/City</label>
									<input type="text" class="form-control" name="street" id="sender_town"
										   :class="{ 'border border-danger': (!$v.sender_address_line_2.required && $v.sender_address_line_2.$dirty)}"
										   v-model="sender_address_line_2" autocomplete="street-town">
									<div class="text-danger"
										 v-if="!$v.sender_address_line_2.required && $v.sender_address_line_2.$dirty">
										Town/City is required
									</div>
								</div>
							</div>


							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_county">County</label>
									<input type="text" class="form-control" name="county" id="sender_county"
										   :class="{ 'border border-danger': (!$v.sender_address_line_3.required && $v.sender_address_line_3.$dirty)}"
										   v-model="sender_address_line_3" autocomplete="address-county">
									<div class="text-danger"
										 v-if="!$v.sender_address_line_3.required && $v.sender_address_line_3.$dirty">
										County is required
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="sender_postcode">Postcode</label>
									<input type="text" class="form-control" name="postcode" id="sender_postcode"
										   :class="{ 'border border-danger': (!$v.sender_address_postcode.required  && $v.sender_address_postcode.$dirty)}"
										   v-model="sender_address_postcode" autocomplete="postal-code">

									<div class="text-danger"
										 v-if="!$v.sender_address_postcode.required && $v.sender_address_postcode.$dirty">
										Postcode is required
									</div>
								</div>
							</div>


						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- gift recipient details -->
		<div class="container" v-if="sponsorFor === 1">
			<div class="row">
				<div class="col-12">
					<hr class="border border-secondary">
				</div>
			</div>

			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="row">
						<div class="col-12">
							<h4>Recipient Details</h4>
						</div>
					</div>
					<div class="row px-3">
						<div class=" col-12 bg-purple-light p-3">
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_title">Title</label>
									<input type="text" class="form-control" name="title" id="recipient_title"
										   :class="{ 'border border-danger': (!$v.recipient_title.required  && $v.recipient_title.$dirty)}"
										   v-model="recipient_title" autocomplete="title"
										   placeholder="e.g, Mr, Mrs, Miss, Dr, Rev, etc">
									<div class="text-danger"
										 v-if="!$v.recipient_title.required && $v.recipient_title.$dirty">
										Title is required.
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_first_name">First Name</label>
									<input type="text" class="form-control" name="first_name" id="recipient_first_name"
										   :class="{ 'border border-danger': (!$v.recipient_first_name.required  && $v.recipient_first_name.$dirty)}"
										   v-model="recipient_first_name" autocomplete="name">
									<div class="text-danger"
										 v-if="!$v.recipient_first_name.required && $v.recipient_first_name.$dirty">
										First name is required
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_last_name">Last Name</label>
									<input type="text" class="form-control" name="last_name" id="recipient_last_name"
										   :class="{ 'border border-danger': (!$v.recipient_last_name.required  && $v.recipient_last_name.$dirty)}"
										   v-model="recipient_last_name" autocomplete="name">
									<div class="text-danger"
										 v-if="!$v.recipient_last_name.required && $v.recipient_last_name.$dirty">
										Last name is required
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_email">Email</label>
									<input type="email" class="form-control" v-model="recipient_email"
										   :class="{ 'border border-danger': (!$v.recipient_email.required  && $v.recipient_email.$dirty)}"
										   name="email" id="recipient_email" autocomplete="email">
									<div class="text-danger"
										 v-if="!$v.recipient_email.required && $v.recipient_email.$dirty">
										Email is required
									</div>
									<div class="text-danger"
										 v-if="!$v.recipient_email.email && $v.recipient_email.$dirty">
										That email address is invalid.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6 mt-3 mt-lg-0">
					<div class="row">
						<div class="col-12">
							<h4>Recipient Address</h4>
						</div>
					</div>
					<div class="row px-3">
						<div class="col-12 bg-purple-light p-3">
							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_street">House number &amp; Street</label>
									<input type="text" class="form-control" name="street" id="recipient_street"
										   :class="{ 'border border-danger': (!$v.recipient_address_line_1.required  && $v.recipient_address_line_1.$dirty)}"
										   v-model="recipient_address_line_1" autocomplete="street-address">
									<div class="text-danger"
										 v-if="!$v.recipient_address_line_1.required && $v.recipient_address_line_1.$dirty">
										Please enter the house number and street.
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_town">Town / City</label>
									<input type="text" class="form-control" name="town" id="recipient_town"
										   :class="{ 'border border-danger': (!$v.recipient_address_line_2.required  && $v.recipient_address_line_2.$dirty)}"
										   v-model="recipient_address_line_2" autocomplete="address-level2">
									<div class="text-danger"
										 v-if="!$v.recipient_address_line_2.required && $v.recipient_address_line_2.$dirty">
										Please enter the town or city.
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_county">County</label>
									<input type="text" class="form-control" name="county" id="recipient_county"
										   :class="{ 'border border-danger': (!$v.recipient_address_line_3.required  && $v.recipient_address_line_3.$dirty)}"
										   v-model="recipient_address_line_3" autocomplete="address-county">
									<div class="text-danger"
										 v-if="!$v.recipient_address_line_3.required && $v.recipient_address_line_3.$dirty">
										Please enter the county.
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-12 col-lg-8">
									<label for="recipient_postcode">Postcode</label>
									<input type="text" class="form-control" name="postcode" id="recipient_postcode"
										   :class="{ 'border border-danger': (!$v.recipient_address_postcode.required  && $v.recipient_address_postcode.$dirty)}"
										   v-model="recipient_address_postcode" autocomplete="postal-code">
									<div class="text-danger"
										 v-if="!$v.recipient_address_postcode.required && $v.recipient_address_postcode.$dirty">
										Please enter the postcode.
									</div>
								</div>
							</div>


						</div>
					</div>

				</div>
			</div>
		</div>


		<div class="container">
			<div class="row">
				<div class="col-12">
					<hr class="border border-secondary">
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<h4>Gift Aid</h4>
				</div>
			</div>

			<!-- gift aid -->
			<div class="row px-3">
				<div class="col-12 bg-purple-light p-3 px-0 px-lg-5 text-left">
					<p class="form-check-label mb-3">
						If you are a UK Income Tax payer you can ask for the tax paid on your donations to Love
						Underdogs to be
						refunded to us by HMRC.
						<br>If you would like us to claim Gift Aid on your donations, please check the box below.
					</p>
					<div class="custom-control custom-control-purple custom-control-lg custom-checkbox pl-1">
						<input id="giftAid" class="custom-control-input " type="checkbox" name="donateGiftaid"
							   v-model="gift_aid">
						<label class="custom-control-label ml-3 font-weight-bold" for="giftAid"> &nbsp;&nbsp;Yes I would
							like tax
							paid on my
							donation to be refunded.</label>
					</div>
				</div>
			</div>
		</div>

		<div class="container m-0 mt-3">
			<div class="row px-3">
				<div class="col-12 col-lg-5 p-0">
					<div class="g-recaptcha" :data-sitekey="recaptchakey"></div>
					<div class="text-danger" v-if="recaptchaError">
						Please check ReCaptcha
					</div>
				</div>
			</div>
		</div>

		<div class="container m-0 mt-3">
			<div class="row px-3">
				<div class="col-12 col-lg-5 p-0">
					<button id="donateButton" class="btn btn-purple btn-lg w-100" type="submit">
						<span class="font-alt">Sponsor {{  profile.name }} for {{ donationButtonText }} &gt;</span>
					</button>
					<p v-if="submitStatus === false" class="mt-3 text-danger">Oops - theres something wrong. <br>Please
						check your details are correct.</p>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import Axios from 'axios'
import PriceBox from './sponsorform/pricebox'
import { required, requiredIf, minLength, email, numeric } from 'vuelidate/lib/validators'

export default {
	name: 'sponsorform',
	props: {
		plans: Array,
		profile: Object,
		recaptchakey: String
	},
	components: {
		PriceBox
	},
	data: function () {
		return {
			errors: {},
			selectedFrequency: 'monthly',
			selectedPlan: this.plans[3].planId,
			selectedAmount: this.plans[3].amount,
			otherAmount: 60,
			sponsorFor: 0, // 0 = 'Me', 1 = 'someone else',
			gift_aid: false,
			submitStatus: null,
			defaultPlan: 0,
			no_pack: false,
			recaptchaError: false,

			oneOffPlans: [
				{
					amount: 50,
					planId: this.oneOffPlanName(50),
					label: '50.00'
				},
				{
					amount: 60,
					planId: this.oneOffPlanName(60),
					label: '60.00'
				},
				{
					amount: 80,
					planId: this.oneOffPlanName(80),
					label: '80.00'
				},
				{
					amount: 100,
					planId: this.oneOffPlanName(100),
					label: '100.00'
				},
				{
					amount: 0,
					planId: this.oneOffPlanName('other'),
					label: 'Other Amount'
				}

			],
			sender_title: null,
			sender_first_name: null,
			sender_last_name: null,
			sender_email: null,
			sender_address_line_1: null,
			sender_address_line_2: null,
			sender_address_line_3: null,
			sender_address_postcode: null,
			recipient_title: null,
			recipient_first_name: null,
			recipient_last_name: null,
			recipient_email: null,
			recipient_address_line_1: null,
			recipient_address_line_2: null,
			recipient_address_line_3: null,
			recipient_address_postcode: null
		}
	},

	validations: {
		selectedAmount: {
			required,
			numeric,
			minValue: 1
		},
		selectedPlan: {
			required
		},
		sender_title: {
			required,
			minLength: minLength(2)
		},
		sender_first_name: {
			required,
			minLength: minLength(1)
		},
		sender_last_name: {
			required,
			minLength: minLength(2)
		},
		sender_email: {
			required,
			email
		},

		sender_address_line_1: {
			required: requiredIf(function () {
				return this.sponsorFor === 0
			})

		},
		sender_address_line_2: {
			required: requiredIf(function () {
				return this.sponsorFor === 0
			})
		},
		sender_address_line_3: {
			required: requiredIf(function () {
				return this.sponsorFor === 0
			})
		},
		sender_address_postcode: {
			required: requiredIf(function () {
				return this.sponsorFor === 0
			})
		},

		recipient_title: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			}),
			minLength: minLength(2)
		},
		recipient_first_name: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			}),
			minLength: minLength(1)
		},
		recipient_last_name: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			}),
			minLength: minLength(2)
		},
		recipient_email: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			}),
			email
		},

		recipient_address_line_1: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			})
		},
		recipient_address_line_2: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			})
		},
		recipient_address_line_3: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			})
		},
		recipient_address_postcode: {
			required: requiredIf(function () {
				return this.sponsorFor === 1
			})
		}
	},

	computed: {
		donationButtonText: function () {
			let text = '£' + this.selectedAmount + '.00'

			if (this.selectedFrequency === 'monthly') {
				text += ' per month'
			}
			return text
		}
	},

	methods: {
		selectPlan: function (payload) {
			this.selectedPlan = payload.plan
			this.selectedFrequency = payload.frequency
			this.selectedAmount = payload.amount
		},

		oneOffPlanName (amount) {
			return 'one-off-' + this.profile.name.toLowerCase() + '-' + amount
		},

		validate: function () {
			// validate that all fields are good and then send
			const valueRegex = new RegExp(/\d+/)
			const planRegex = new RegExp(/(.*)-(.*)/)
			if (!this.selectedAmount || !valueRegex.test(this.selectedAmount)) {
				this.errors.amount = 'Amount is invalid'
				return
			}

			if (!planRegex.test(this.selectedPlan) || this.selectedPlan.length < 5) {
				this.errors.plan = 'Invalid Plan selected'
				return
			}
		},

		submit: function () {
			this.$v.$touch()
			if (this.$v.$invalid) {
				this.submitStatus = false
			} else {
				// do your submit logic here
				this.submitStatus = true

				const gcaptchaResponse = grecaptcha.getResponse()

				if (gcaptchaResponse.length === 0) {
					this.recaptchaError = true
					return
				}

				const data = {
					amount: this.selectedAmount * 100,
					frequency: this.selectedFrequency,
					gift_aid: this.gift_aid,
					profile_id: this.profile.id,
					plan: this.selectedPlan,
					sponsorFor: this.sponsorFor ? 'gift' : 'self',
					'g-recaptcha-response': gcaptchaResponse,
					meta: {
						sponsorFor: this.sponsorFor ? 'gift' : 'self',
						send_pack: this.no_pack ? '0' : '1',
						gift_aid: this.gift_aid,
						profile_id: this.profile.id,
						animal_name: this.profile.name,
						donation_type_id: 1,
						sender_title: this.sender_title,
						sender_first_name: this.sender_first_name,
						sender_last_name: this.sender_last_name,
						sender_email: this.sender_email,
						sender_address_1: this.sender_address_line_1,
						sender_address_2: this.sender_address_line_2,
						sender_address_3: this.sender_address_line_3,
						sender_address_4: this.sender_address_postcode,

						recipient_title: (this.sponsorFor === 1 ? this.recipient_title : this.sender_title),
						recipient_first_name: (this.sponsorFor === 1 ? this.recipient_first_name : this.sender_first_name),
						recipient_last_name: (this.sponsorFor === 1 ? this.recipient_last_name : this.sender_last_name),
						recipient_email: (this.sponsorFor === 1 ? this.recipient_email : this.sender_email),
						recipient_address_1: (this.sponsorFor === 1
								? this.recipient_address_line_1
								: this.sender_address_line_1),
						recipient_address_2: (this.sponsorFor === 1
								? this.recipient_address_line_2
								: this.sender_address_line_2),
						recipient_address_3: (this.sponsorFor === 1
								? this.recipient_address_line_3
								: this.sender_address_line_3),
						recipient_address_4: (this.sponsorFor === 1
								? this.recipient_address_postcode
								: this.sender_address_postcode)
					}
				}

				Axios.post('/api/stripe/session', data).then(response => {
					// stripe keys
					const stripeKey = document.querySelector('#stripe-script').dataset.key
					const stripe = Stripe(stripeKey)
					stripe.redirectToCheckout({
						sessionId: response.data.session_id
					})
				})
				.catch((err) => {
					if (err.response.data) {
						this.recaptchaError = true
						grecaptcha.reset()
					}
				})
			}
		},

		setTitle (value) {
			this.sender_title = value
			this.$v.sender_title.$touch()
		}
	},

	mounted: function () {
		// pre-select first plan
		this.selectedPlan = this.plans[0].planId
		this.selectedAmount = this.plans[0].amount
		// this.selectPlan({ plan: this.plans[0].planId, frequency: 'monthly', amount: this.plans[0].amount })
		this.$refs.priceBoxMonthly.$forceUpdate()
		this.$refs.priceBoxOneOff.$forceUpdate()
	}

}
</script>

<style>

.border-purple {
	border: solid 2px #877aaa;
}

.cursor-pointer {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/sponsorform.vue